import request from '@/utils/request'

// 查询三同企业发布管理列表
export function listStqyfb(query) {
  return request({
    url: '/web/zlts/stqyfb/list',
    method: 'get',
    params: query
  })
}

// 查询三同企业发布管理详细
export function getStqyfb(recid) {
  return request({
    url: '/web/zlts/stqyfb/' + recid,
    method: 'get'
  })
}
